export default (url) => {
  // eslint-disable-next-line no-useless-escape
  url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/)

  if (RegExp.$3.indexOf('youtu') > -1) {
    return RegExp.$6
  }

  return null
}
